import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IFullFranchiseItem, IHome_FranchisesResponse } from '@shared/constants/models.const';

@Injectable({
  providedIn: 'root',
})
export class FranchiseService {
  private franchisesList$ = new BehaviorSubject<IHome_FranchisesResponse[] | undefined>(undefined);
  private currentFranchise$ = new BehaviorSubject<IFullFranchiseItem | undefined>(undefined);

  constructor() { }

  getFranchisesList(): BehaviorSubject<IHome_FranchisesResponse[] | undefined> {
    return this.franchisesList$;
  }

  getCurrentFranchise(): BehaviorSubject<IFullFranchiseItem | undefined> {
    return this.currentFranchise$;
  }

  setFranchisesList(value: IHome_FranchisesResponse[] | undefined) {
    this.franchisesList$.next(value);
  }

  setCurrentFranchise(value: IFullFranchiseItem | undefined) {
    this.currentFranchise$.next(value);
  }
}
